import React from 'react';
import './InfoCustomerService.scss';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';

interface IProps {
  content: Julius.Website.ServicePageViewModel;
}

const InfoCustomerService: React.SFC<IProps> = ({
  content,
}) => {

  if (!content) {
    return null;
  }

  const { title, text } = content;

  return (
    <WrapperLayout style='customerservice'>
      <div className='customerservice-title'>{ title }</div>
      <div dangerouslySetInnerHTML={ { __html: text } } />
    </WrapperLayout>
  );
};

export default InfoCustomerService;


// WEBPACK FOOTER //
// ./src/components/InfoCustomerService/InfoCustomerService.tsx